import { render, staticRenderFns } from "./moedaComSinal.vue?vue&type=template&id=54c41dba"
import script from "./moedaComSinal.ts?vue&type=script&lang=js&external"
export * from "./moedaComSinal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c41dba')) {
      api.createRecord('54c41dba', component.options)
    } else {
      api.reload('54c41dba', component.options)
    }
    module.hot.accept("./moedaComSinal.vue?vue&type=template&id=54c41dba", function () {
      api.rerender('54c41dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/moedaComSinal.vue"
export default component.exports